import { create } from 'zustand';
import { InspectionType, InspectionStatusType } from '@apply/constants';
import { IInspection, IInspectionsData } from '../interfaces/interfaces';

interface InspectionsModalStoreState {
    drawBudgetId: number;
    currentInspection: IInspection | null;
    isNewInspection: boolean;
    drawId: string | number | null;
    inspectionType: InspectionType;
    fileIds: number[];

    setDrawBudgetId: (id: number) => void;
    setCurrentInspection: (inspection: IInspection | null) => void;
    setIsNewInspection: (value: boolean) => void;
    setDrawId: (id: string | number | null) => void;
    setInspectionType: (type: InspectionType) => void;
    setFileIds: (ids: number[]) => void;
    reset: () => void;
}

const initialState = {
    drawBudgetId: 0,
    currentInspection: null,
    isNewInspection: false,
    drawId: null as string | number | null,
    inspectionType: InspectionType.Status,
    fileIds: [] as number[],
};

export const useInspectionsModalStore = create<InspectionsModalStoreState>((set) => ({
    ...initialState,
    setDrawBudgetId: (id) => set({ drawBudgetId: id }),
    setCurrentInspection: (inspection) => set({ currentInspection: inspection }),
    setIsNewInspection: (value) => set({ isNewInspection: value }),
    setDrawId: (id) => set({ drawId: id }),
    setInspectionType: (type) => set({ inspectionType: type }),
    setFileIds: (ids) => set({ fileIds: ids }),
    reset: () => set(initialState),
}));

// Pure helpers computed from inspectionsData — usable in any component without prop drilling

export const canOrderStatusInspection = (data: IInspectionsData | null): boolean => {
    if (!data) return false;
    const statusInspections = data.inspections.filter((i) => i.inspectionTypeId === InspectionType.Status);
    return statusInspections.every((i) => i.statusId === InspectionStatusType.InspectionDelivered);
};

export const canOrderDrawInspection = (data: IInspectionsData | null, id?: number): boolean => {
    if (!data) return false;
    const drawInspections = data.inspections.filter((i) => i.inspectionTypeId === InspectionType.Draw);
    if (id !== undefined) {
        const draw = data.draws.find((a) => a.id === id);
        const insp = data.inspections.find((a) => a.drawId === id);
        return !!(draw && !insp);
    }
    return data.draws.some((d) => !drawInspections.find((i) => i.drawId === d.id));
};
